export default {
  "config": {
    "trial": "tones-3",
    "id": "participant-disposition",
    "type": "design",
    "title": "Participant Disposition for the  TONES 3 Study of Efficacy and Safety of Solriamfetol in Adults With OSA and EDS<sup>23</sup>",
    "footnotes": [
      "The maximum recommended dose for solriamfetol in the USA PI is 150 mg.<sup>27</sup>",
      "Participant disposition (consolidated standards of reporting trials diagram). Fifteen participants in the randomized population did not have baseline or one or more postbaseline evaluations of maintenance of wakefulness test sleep latency or Epworth sleepiness scale score, and two did not receive solriamfetol. These participants did not meet the prespecified criteria for inclusion in the mITT population."
    ],
    "useFootnoteTooltip": true
  },
  "data": {
    "trial": "tones-3",
    "id": "participant-disposition",
    "data-type": "design",
    "title": "Participant Disposition for the  TONES 3 Study of Efficacy and Safety of Solriamfetol in Adults With OSA and EDS<sup>23</sup>",
    "footnote-tooltip": "enable",
    "footnote-order": [
      "footnote-note1",
      "footnote-note2"
    ],
    "footnote-note1": "The maximum recommended dose for solriamfetol in the USA PI is 150 mg.<sup>27</sup>",
    "footnote-note2": "Participant disposition (consolidated standards of reporting trials diagram). Fifteen participants in the randomized population did not have baseline or one or more postbaseline evaluations of maintenance of wakefulness test sleep latency or Epworth sleepiness scale score, and two did not receive solriamfetol. These participants did not meet the prespecified criteria for inclusion in the mITT population."
  }
};